var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUserAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8182 11.5C9.755 11.5 5.63636 12.4975 5.63636 14.5V16H18V14.5C18 12.4975 13.8814 11.5 11.8182 11.5ZM4.86364 8.5V6.25H3.31818V8.5H1V10H3.31818V12.25H4.86364V10H7.18182V8.5M11.8182 10C12.6379 10 13.4241 9.68393 14.0038 9.12132C14.5834 8.55871 14.9091 7.79565 14.9091 7C14.9091 6.20435 14.5834 5.44129 14.0038 4.87868C13.4241 4.31607 12.6379 4 11.8182 4C10.9984 4 10.2122 4.31607 9.63258 4.87868C9.05292 5.44129 8.72727 6.20435 8.72727 7C8.72727 7.79565 9.05292 8.55871 9.63258 9.12132C10.2122 9.68393 10.9984 10 11.8182 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserAdd);
export default __webpack_public_path__ + "static/media/icon-user-add.963843074a229c831f680f1db887d1ca.svg";
export { ForwardRef as ReactComponent };